import Vue from 'vue'
import App from './App.vue'
import VueLocalStorage from 'vue-localstorage'


Vue.config.productionTip = false
Vue.use(VueLocalStorage)

Vue.component('modal', {
    template: '#modal-template'
})

new Vue({
  render: h => h(App),
}).$mount('#app')

$(function(){
  $('.twitter').click(function(){
    $('nav').toggleClass('open');
  });
})
